module.exports = __webpack_public_path__ + "img/rose_half.d4217976.svg";